import React from 'react';
// import { Link } from "gatsby";
// import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function PartnersBox(props) {
  const { partners, partnersText } = props;

  return (
    <div className="partnershipContainer partners-meta-box meta-box">
      {partners && partners.length ? (
        <div className="grid grid-cols-2">
          <h1 className="meta-header">{partnersText}</h1>
          {partners.map((partner) => (
            <div className="col-span-1 md:col-span-full">
              <a
                href={partner.partnerUrl}
                className="block py-2 pr-0 grayscale hover:grayscale-0 lg:pr-4"
              >
                {partner.partnerLogo && (
                  <img
                    src={partner.partnerLogo.publicURL}
                    alt={partner.partnerTitle}
                  />
                )}
                {/* {partner.partnerLogo &&
								partner.partnerLogo.extension == "svg" ? (
									<img
										src={partner.partnerLogo.publicURL}
										alt={partner.partnerTitle}
									/>
								) : (
									<GatsbyImage
										image={getImage(partner.partnerLogo)}
										alt={partner.partnerTitle}
									/>
								)} */}
              </a>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
